/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_AgainInputs */

const fr_auth_sign_in_again = /** @type {(inputs: Auth_Sign_In_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se reconnecter`)
};

const en_auth_sign_in_again = /** @type {(inputs: Auth_Sign_In_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in again`)
};

/**
* | output |
* | --- |
* | "Sign in again" |
*
* @param {Auth_Sign_In_AgainInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_again = /** @type {((inputs?: Auth_Sign_In_AgainInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_AgainInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in_again(inputs)
	return fr_auth_sign_in_again(inputs)
});